<div class="security-sliders">
  <app-settings-slider
    (change)="checkForChanges()"
    [(modelNg)]="securitySettings!.encryption"
    [choiceDescriptor]="securitySettings!.encryption ? 'verschlüsselt' : 'unverschlüsselt'"
    [disabled]="securitySettings?.visibility === Visibility.Private || room?.isEncrypted === true"
    settingDescriptor="1. Verschlüsselung"
    [attr.data-testid]="testIds.encryptionSlider" />
</div>
<div class="setting-container">
  <p class="setting-descriptor">2. Sichtbarkeit</p>
  @let isPrivate = securitySettings!.visibility === Visibility.Private;
  <div class="item-container">
    <mat-chip-listbox class="chip-set">
      <app-chip
        [dataTestId]="testIds.buttonVisibilityPrivate"
        [title]="'Privat'"
        [isDisabled]="!roomPowerLevelService.canDoEvent(EventType.RoomHistoryVisibility, powerLevels, userId)"
        (clicked)="changeAccess(Visibility.Private)"
        matTooltip="Beitritt zum Chat nur nach Einladung möglich"
        avatarIcon="key"
        [isHighlighted]="isPrivate" />
      <app-chip
        [dataTestId]="testIds.buttonVisibilityPublic"
        [title]="'Öffentlich'"
        [isDisabled]="
          !roomPowerLevelService.canDoEvent(EventType.RoomHistoryVisibility, powerLevels, userId) ||
          room?.roomAccess === 'private'
        "
        (clicked)="changeAccess(Visibility.Public)"
        matTooltip="Sichtbar und zugänglich für jeden"
        avatarIcon="globe"
        [isHighlighted]="!isPrivate" />
    </mat-chip-listbox>
  </div>
</div>
<div class="setting-container">
  <p class="setting-descriptor">3. Berechtigung/Zutritt</p>
  <div class="item-container">
    <mat-checkbox
      [ngModel]="securitySettings!.visibility === Visibility.Private"
      class="tim-checkbox"
      disabled="disabled"></mat-checkbox>
    <p>Auf Einladung</p>
  </div>
</div>
<div class="setting-container">
  <div class="setting-descriptor">4. Raumhistorie/Nachrichtenverlauf</div>

  <div class="item-container">
    <span>
      <app-tooltip-icon [infoText]="infoText" [infoTitle]="'Nachrichtenverlauf sichtbar ab'" />
      <p>Mitglieder können den bisherigen Verlauf lesen:</p>
    </span>
    <mat-radio-group
      [(ngModel)]="securitySettings!.history"
      (change)="checkForChanges()"
      class="security-radio-group"
      [disabled]="!roomPowerLevelService.canDoEvent(EventType.RoomHistoryVisibility, powerLevels, userId)">
      <span
        matTooltip="Eingeladene Mitglieder sehen den historischen Nachrichtenverlauf ab dem Zeitpunkt der Einladung">
        <mat-radio-button [attr.data-testid]="testIds.radioHistoryInvited" [value]="'invited'" class="tim-radiobutton">
          Ab Einladung
        </mat-radio-button>
      </span>
      <span matTooltip="Neue Mitglieder sehen den historischen Nachrichtenverlauf ab dem Zeitpunkt des Beitritt">
        <mat-radio-button [attr.data-testid]="testIds.radioHistoryJoined" [value]="'joined'" class="tim-radiobutton">
          Ab Beitritt
        </mat-radio-button>
      </span>
      <span matTooltip="Neue Mitglieder sehen den historischen Nachrichtenverlauf">
        <mat-radio-button [attr.data-testid]="testIds.radioHistoryShared" [value]="'shared'" class="tim-radiobutton">
          Vollständig
        </mat-radio-button>
      </span>
      <span matTooltip="Jeder kann ggf. den historischen Nachrichtenverlauf einsehen (auch ohne Beitritt)">
        <mat-radio-button
          [attr.data-testid]="testIds.radioHistoryWorldReadable"
          [value]="'world_readable'"
          class="tim-radiobutton"
          disabled>
          Jeder
        </mat-radio-button>
      </span>
    </mat-radio-group>
  </div>
</div>

<div class="buttons">
  <app-button
    (clicked)="onSave()"
    [dataTestId]="testIds.buttonSaveSecurity"
    [isDisabled]="!roomPowerLevelService.canDoEvent(EventType.RoomHistoryVisibility, powerLevels, userId)"
    [isPrimary]="true"
    text="Speichern"
    tooltip="Sicherheitseinstellungen für Raum speichern"
    tooltipPosition="left">
  </app-button>
</div>
